import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "title", "extra", "footer", "bordered", "noHover", "active", "bodyStyle", "bodyClassName", "children"];
import React, { useMemo } from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-card',
      className,
      title,
      extra,
      footer,
      bordered = true,
      noHover = false,
      active = false,
      bodyStyle,
      bodyClassName,
      children
    } = props,
    resetProps = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = useMemo(() => [prefixCls, className, bordered ? prefixCls + "-bordered" : null, noHover ? prefixCls + "-no-hover" : null, active ? 'active' : null].filter(Boolean).join(' ').trim(), [prefixCls, className, bordered, noHover]);
  return /*#__PURE__*/_jsxs("div", _extends({}, resetProps, {
    className: cls,
    ref: ref,
    children: [(title || extra) && /*#__PURE__*/_jsxs("div", {
      className: prefixCls + "-head",
      children: [title && /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-head-title",
        children: title
      }), extra && /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-extra",
        children: extra
      })]
    }), children && /*#__PURE__*/_jsx("div", {
      className: [prefixCls + "-body", bodyClassName].filter(Boolean).join(' ').trim(),
      style: bodyStyle,
      children: children
    }), footer && /*#__PURE__*/_jsx("div", {
      className: prefixCls + "-footer",
      children: footer
    })]
  }));
});